import { withWindow } from '@shared/utils/withWindow';

export const initBuildNum = () => {
  withWindow(window => {
    window.buildNumber = process.env.BUILD_NUM || '0.0.1';
    // eslint-disable-next-line no-console
    console.log('Build number: ' + window.buildNumber);
  });
};
